import { BaseClusterRenderer, MarkerTypeConfig } from '../../../../_shared/interfaces/maps/base-cluster-renderer';

export class WorkshopClusterRenderer extends BaseClusterRenderer {
  protected override getMarkerTypesConfig(): { [key: string]: MarkerTypeConfig } {
    return {
      'default': { color: '#EE2737', pulsate: true }
    };
  }

  protected override getMarkerType(marker: google.maps.marker.AdvancedMarkerElement): string | null {
    return 'default';
  }
}